import {
  RECEIVE_CONTACTS,
  RECEIVE_REMOVE_CONTACT,
  RECEIVE_UPDATE_CLOSE_CONTACT,
  RECEIVE_UPDATE_CONTACT,
  REQUEST_REMOVE_CONTACT,
  REQUEST_REMOVE_CONTACT_FAILED,
  REQUEST_UPDATE_CLOSE_CONTACT,
  REQUEST_UPDATE_CLOSE_CONTACT_FAILED,
  REQUEST_UPDATE_CONTACT,
  REQUEST_UPDATE_CONTACT_FAILED,
  RESET_ERROR,
} from './actions';

export const errors = {
  UPDATE_CONTACT_FAILED: 'UPDATE_CONTACT_FAILED',
  REMOVE_CONTACT_FAILED: 'REMOVE_CONTACT_FAILED',
  UPDATE_CLOSE_CONTACT_FAILED: 'UPDATE_CLOSE_CONTACT_FAILED',
};

export const initialState = {
  data: [],
  error: null,
  isFetching: false,
};

export const reducer = (state, action) => {
  let { type, payload } = action;
  switch (type) {
    case REQUEST_UPDATE_CONTACT:
    case REQUEST_UPDATE_CLOSE_CONTACT:
    case REQUEST_REMOVE_CONTACT:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_CONTACTS:
    case RECEIVE_UPDATE_CONTACT:
    case RECEIVE_UPDATE_CLOSE_CONTACT:
    case RECEIVE_REMOVE_CONTACT:
      return {
        ...state,
        data: payload.data,
        isFetching: false,
      };
    case REQUEST_UPDATE_CONTACT_FAILED:
      return {
        ...state,
        isFetching: false,
        error: errors.UPDATE_CONTACT_FAILED,
      };
    case REQUEST_REMOVE_CONTACT_FAILED:
      return {
        ...state,
        isFetching: false,
        error: errors.REMOVE_CONTACT_FAILED,
      };
    case REQUEST_UPDATE_CLOSE_CONTACT_FAILED:
      return {
        ...state,
        isFetching: false,
        error: errors.UPDATE_CLOSE_CONTACT_FAILED,
      };
    case RESET_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
};
